import { acceptTosVersion } from './API';

const AcceptTosVersion = async (groupId, tosVersion, accessToken) => {

    try {
        const response = await acceptTosVersion(groupId, tosVersion, accessToken);
        return { success: true, data: response.data };
    } catch (error) {
        return { success: false, data: error.response.data.message };
    }
};

export default AcceptTosVersion;